// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LaptopSimpleOutlinedSvg from "@fishx/icons-svg/es/asn/LaptopSimpleOutlined";
import FishxIcon from '../components/FishxIcon';

var LaptopSimpleOutlined = function LaptopSimpleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LaptopSimpleOutlinedSvg
  }));
};

LaptopSimpleOutlined.displayName = 'LaptopSimpleOutlined';
export default React.forwardRef(LaptopSimpleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LaptopSimpleOutlined.js
// module id = 3014
// module chunks = 0